import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { formatNumber } from '@agro1desenvolvimento/utils-js';
import { DefensivoFormValue, TratamentoFormValue } from '../../../../@types';
import defaultColumnProps from '../../../../utils/default-column-props';
import { isSegundoTratamento } from '../utils';

const TratamentoDeSementesParametrosRowExpansion = (
  tratamento: TratamentoFormValue,
) => {
  const segundoTratamento =
    isSegundoTratamento(tratamento) || !tratamento.unidade;

  return (
    <DataTable
      dataKey="item.id"
      value={tratamento.defensivos}
      className="mx-auto w-4 table-row-expansion"
      emptyMessage="Nenhum defensivo foi escolhido para esse tratamento"
    >
      <Column
        {...defaultColumnProps('left', false)}
        header="Insumo"
        field="item.descricao"
      />
      <Column
        {...defaultColumnProps('right', false)}
        header={segundoTratamento ? 'Quantidade' : 'Dose'}
        body={(data: DefensivoFormValue) => {
          const formattedValue = formatNumber(
            (segundoTratamento ? data.quantidade : data.dose) || 0,
            {
              maximumFractionDigits: 4,
            },
          );
          const unidade = data.item.unidade.abreviatura || '';

          return `${formattedValue} ${unidade}${
            segundoTratamento ? '' : '/100kg'
          }`;
        }}
      />
    </DataTable>
  );
};

export default TratamentoDeSementesParametrosRowExpansion;
